import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { filter, pipe, switchMap, tap } from 'rxjs';
import { Article } from '../model/article.model';
import { CMSPaginatedResponse } from '../model/cms-response.model';
import { KnowledgeService } from '../service/knowledge.service';

export const ArticleStore = signalStore(
  withDevtools('article'),
  withState({
    data: null as CMSPaginatedResponse<Article> | null,
  }),
  withRequestStatus(),
  withMethods((store, knowledgeService = inject(KnowledgeService)) => ({
    load: rxMethod<void>(
      pipe(
        filter(() => !store.isFulfilled()),
        tap(() => updateState(store, '[ArticleStore] Set pending', setPending())),
        switchMap(() =>
          knowledgeService.getArticles().pipe(
            tapResponse({
              next: (data) => {
                updateState(store, '[ArticleStore] Set fulfilled', setFulfilled());
                updateState(store, '[ArticleStore] Set data', { data });
              },
              error: () => {
                updateState(store, '[ArticleStore] Set error', setError());
                updateState(store, '[ArticleStore] Set data', { data: null });
              },
            }),
          ),
        ),
      ),
    ),
  })),
);
